"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var three_sixty_1 = require("@shared/types/three-sixty");
var angular = __importStar(require("angular"));
var lodash_1 = __importDefault(require("lodash"));
var person_metadata_utils_1 = require("@shared/utils/person-metadata-utils");
var PersonMetadataMenuService = /** @class */ (function () {
    function PersonMetadataMenuService($filter, personService) {
        this.$filter = $filter;
        this.personService = personService;
        this.translate = this.$filter('translate');
    }
    PersonMetadataMenuService.prototype.addMenus = function (fieldSetView) {
        var _this = this;
        return this.personService.getMetadata()
            .then(function (metadata) {
            _this.metadata = metadata;
            _this.removeMetadataFields(fieldSetView);
            _this.addMenusToFieldset(fieldSetView);
            return fieldSetView;
        })
            .catch(function (error) {
            console.error('Problem formatting person metadata submenu', error);
        });
    };
    PersonMetadataMenuService.prototype.removeMetadataFields = function (fieldSetView) {
        var _this = this;
        lodash_1.default.remove(fieldSetView, function (field) {
            var fieldId = lodash_1.default.get(field, 'fieldId');
            fieldId = person_metadata_utils_1.stripSubjectPrefix(fieldId);
            return lodash_1.default.includes(_this.metadata, fieldId);
        });
    };
    PersonMetadataMenuService.prototype.addMenusToFieldset = function (fieldSetView) {
        var subjectMenu = {
            description: this.translate('PR.SUBJECT_METADATA'),
            fields: this.getSubjectSubmenu(),
            meta: {
                fullType: "Submenu" /* Submenu */
            }
        };
        var evaluatorMenu = {
            description: this.translate('PR.EVALUATOR_METADATA'),
            fields: this.getEvaluatorSubmenu(),
            meta: {
                fullType: "Submenu" /* Submenu */
            }
        };
        fieldSetView.push(subjectMenu, evaluatorMenu);
    };
    PersonMetadataMenuService.prototype.getSubjectSubmenu = function () {
        return lodash_1.default.map(this.metadata, function (field) {
            var subjectField = "" + three_sixty_1.SUBJECT_FIELD_PREFIX + field;
            return {
                description: field,
                fieldId: subjectField,
                name: '',
                type: "PersonMetadata" /* PersonMetadata */,
                meta: {
                    fullDescription: subjectField,
                    fullType: "PersonMetadata" /* PersonMetadata */,
                    iconClass: '',
                    sourceId: subjectField
                }
            };
        });
    };
    PersonMetadataMenuService.prototype.getEvaluatorSubmenu = function () {
        return lodash_1.default.map(this.metadata, function (field) {
            var evaluatorField = field;
            return {
                description: field,
                fieldId: evaluatorField,
                name: '',
                type: "PersonMetadata" /* PersonMetadata */,
                meta: {
                    fullDescription: evaluatorField,
                    fullType: "PersonMetadata" /* PersonMetadata */,
                    iconClass: '',
                    sourceId: evaluatorField
                }
            };
        });
    };
    PersonMetadataMenuService.$inject = [
        '$filter',
        'pr.personService'
    ];
    return PersonMetadataMenuService;
}());
(function (angularModule) {
    angularModule.service('prPersonMetadataMenuService', PersonMetadataMenuService);
})(angular.module('qualtrics.pr'));
